import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
const CustomPaper = styled(Paper)(({ theme }) => ({
  "&.MuiPaper-root": {
    borderRadius: "0px",
  },
}));

export default CustomPaper;
